import React from 'react';
import { useAuth } from '../../context/AuthContext';

/**
 * Quién está firmando las peticiones AHORA MISMO.
 *
 * El 16-ago-2026 la interfaz mostró a `plachi` (superadmin, con su foto) durante
 * doce minutos mientras cada petición salía firmada como `Ciocan`, un `member`.
 * Nadie podía verlo: la pantalla no decía en ningún sitio con qué identidad se
 * estaba hablando con el servidor. Cinco horas para encontrarlo.
 *
 * **El nombre sale del token**, no del perfil cacheado: es literalmente el `sub`
 * del JWT que viaja en cada `Authorization`. Si vuelve a divergir, se ve aquí en
 * el primer minuto.
 *
 * **El rol sale del perfil, y no puede salir del token**: el JWT sólo lleva
 * `sub`, `tenant` y `exp` (`auth_service.py:57`). Lo que hace fiable al rol
 * ahora es que el perfil cacheado se valida contra el `sub` antes de usarse
 * (`utils/tokenIdentity.js`), así que sólo puede ser el perfil de quien firma.
 * Si alguna vez faltara esa validación, el rol volvería a poder mentir — y por
 * eso se pinta un `·` entre los dos y no una frase que los funda en uno.
 */
export default function ActiveIdentityLabel({ compact = false }) {
  const auth = useAuth();
  const nombre = auth?.tokenUsername;
  if (!nombre) return null;

  const rol = auth?.user?.role || null;
  const coincide =
    !auth?.user?.username ||
    String(auth.user.username).trim().toLowerCase() === String(nombre).trim().toLowerCase();

  return (
    <span style={{ fontSize: compact ? '0.8em' : '0.9em' }} data-testid="active-identity">
      <span style={{ color: 'var(--archon-footer-text-muted)', marginRight: '5px' }}>Usuario:</span>
      <span style={{ color: 'var(--archon-accent)', fontWeight: 'bold' }}>{nombre}</span>
      {rol && coincide && (
        <>
          <span style={{ color: 'var(--archon-footer-text-muted)', margin: '0 4px' }}>·</span>
          <span style={{ color: 'var(--archon-accent)' }}>{rol}</span>
        </>
      )}
      {!coincide && (
        // Cinturón y tirantes: si el perfil no es el del token, no se enseña su
        // rol. Antes que un rol equivocado, ninguno.
        <span style={{ color: 'var(--archon-footer-text-muted)', marginLeft: 4 }}>
          (perfil sin verificar)
        </span>
      )}
    </span>
  );
}
